import CargoCompanyDispatchListRequest from "../../../../api/raily/cargo-company/dispatch/list/cargo-company-dispatch-list.request";
import paginationService from "../../../../utils/pagination/pagination.service";
import CargoCompanyDispatchListParams from "./cargo-company-dispatch-list-params";

const create = (
  params: CargoCompanyDispatchListParams,
): CargoCompanyDispatchListRequest => {
  return {
    cargoCompanyId: params.cargoCompanyUuid,
    limit: params.pageSize,
    offset:
      params.page && params.pageSize
        ? paginationService.calculateOffset(params.page, params.pageSize)
        : undefined,
  };
};

const cargoCompanyDispatchListParamsFactory = {
  create,
};

export default cargoCompanyDispatchListParamsFactory;
